import { render, staticRenderFns } from "./StatementMetaApplyTargetDialog.vue?vue&type=template&id=17b8c007&lang=pug"
import script from "./StatementMetaApplyTargetDialog.vue?vue&type=script&lang=js"
export * from "./StatementMetaApplyTargetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports